<template>
  <router-view />
</template>

<script>

export default {
  name: 'App',
  mounted() {
    document.title = '识日 - 高效学日语';
  }
}
</script>
